export enum ChildRelationship {
    BIOLOGICAL_CHILD = 'Biological child',
    STEP_CHILD = 'Stepchild',
    FOSTER_CHILD = 'Foster child',
    ADOPTED_CHILD = 'Adopted child',
    LEGAL_WARD = 'Legal ward',
    SPOUSE_DOMESTIC_PARTNERS_CHILD = 'Spouse/Domestic partner\'s child',
    LOCO_PARENTIS = 'Loco parentis'
}